import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { space } from 'styled-system'
import { themeGet } from '@styled-system/theme-get'

import Heading from '../Heading'
import Button from '../Button'

const shrinkStyles = props =>
  props.shrink &&
  `
    width: 100px;
    white-space: nowrap;
  `

const TableHeader = styled.thead``

const TableBody = styled.tbody``

const TableRow = styled.tr``

const TableHeading = styled(Heading.H3)`
  font-weight: ${({ theme }) => theme.fontWeights.regular};
  margin: 0;
  ${space};
`

const TableHeaderCell = styled(({ children, ml, className }) => {
  return (
    <th className={className}>
      <TableHeading ml={ml}>{children}</TableHeading>
    </th>
  )
})`
  width: ${({ width }) => width || 'auto'};
  ${shrinkStyles};
`

const TableCell = styled.td`
  width: ${({ width }) => width || 'auto'};

  font-size: 0.875rem;
  color: ${({ theme }) => theme.colors.text.dark.secondary};

  ${shrinkStyles};
`

const TableButton = styled(Button).attrs({
  tiny: true,
  variant: 'secondary',
})``

const Table = styled.table`
  width: 100%;
  text-align: left;
  border-collapse: collapse;
  table-layout: ${props => (props.fixed ? 'fixed' : 'auto')};

  ${TableHeader}, ${TableRow} {
    border-bottom: 1px solid ${({ theme }) => theme.colors.border.dark.base};
    vertical-align: middle;
  }

  ${TableRow /* sc-selector */}:last-child {
    border-bottom: none;
  }

  ${TableHeaderCell /* sc-selector */}, ${TableCell} {
    padding: ${themeGet('space.3')}px 0;
  }
`

Table.propTypes = {
  // Set table-layout to fixed for fixed width columns
  fixed: PropTypes.bool,
}

Table.Header = TableHeader
Table.Body = TableBody
Table.Row = TableRow
Table.HeaderCell = TableHeaderCell
Table.Cell = TableCell
Table.Button = TableButton

export default Table
